<template>
  <div class="text-left">
    <div class="flex-between" style="margin-bottom:64px">
      <div class="size-21" style="color:#363636">솔루션 이용 플랜 수정</div>
      <!--<img :src="svgSrc('fi_close_outline')" class="svg-sub2 unselect" @click="$emit('close')">-->
    </div>

    <template>
      <!-- 다음 결제일 갱신 예정 내역 -->
      <template>
        <div class="terminate-modal-title" style="margin-bottom:24px;margin-top:60px">
          이용 중인 서비스 - 다음 결제일 갱신 예정 내역
          <div class="terminate-modal-content" style="margin-top:8px">
            {{ expectedPayDay }} 결제 예정 <br> {{ description }}
          </div>
        </div>
        <div v-if="list3.length>0">
          <table class="table amt-table" style="width:100%">
            <thead>
            <tr>
              <th class="col-1">구매일</th>
              <th class="col-1">결제예정일</th>
              <th class="col-1">구분</th>
              <th class="col-1">내용</th>
              <th class="col-3"></th>
              <th class="col-1">플랜</th>
              <th class="col-3">서비스 이용기간</th>
              <th class="col-1">금액</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(order, order_idx) in list3" :key="`order-${order_idx}`">
              <template>
                <td>{{ order.purchase_date }}</td>
                <td>{{ order.next_date }}</td>
                <td>{{ order.order_type }}</td>
                <td>{{ order.content1 }}</td>
                <td>{{ order.content2 }}</td>
                <td>{{ order.plan }}</td>
                <td>{{ order.period }}</td>
                <td>{{ order.price | currency }}</td>
              </template>
            </tr>
            </tbody>
          </table>
          <div class="flex-end" style="padding:0 30px">
            <div style="font-size:11px;font-weight:500;color:#363636;">
              {{ expectedPayDay }} 갱신 예정 금액</div>
            <div style="font-size:11px;margin-left:24px">{{ totalPriceList3 | currency }}</div>
          </div>
        </div>
        <div style="font-weight:400;color:#363636;font-size:11px" v-else>다음 결제일 갱신 내역이 없습니다.</div>

      </template>

      <div class="flex-end" style="padding: 0 30px;margin-top:24px;font-size:13px;">
        <div style="font-weight:bold;color:#363636;">총 결제 금액(부가세 포함)</div>
        <div style="margin-left:24px">{{ accountTotalPrice | currency }}</div>
      </div>

    </template>

    <div class="flex-center" style="margin-top:39px;margin-bottom:32px">
      <lp-check-bool :checkedVal.sync="check" v-if="accountTotalPrice>0"
                     label="결제 동의"></lp-check-bool>
    </div>
    <div class="flex-center" style="margin-bottom:5px;font-size:11px;font-weight:500;color:#363636"
         v-if="isUpgrade">
      결제 수단
      <span class="margin-left-8">{{ service.credit_card }}</span>
    </div>
    <div class="flex-center" style="margin-top:6px">
      <button class="button t-modal-btn" style="height:42px !important;" @click="saveData">
        <span>결제</span>
      </button>
    </div>
  </div>
</template>
<script>
  import moment from 'moment'
  import LpCheckBool from "../../../module/common/LpCheckBool";
  import ToolTip1 from "../../../module/common/ToolTip1";
  export default {
    name: "ServiceRecoverModal",
    props: {
      service: {
        type: Object
      },
      order_product: {
        type: Object
      },
      selectorStocks: {
        type: Array
      }
    },
    components: {ToolTip1, LpCheckBool},
    created() {
      this.initPlan();
    },
    data() {
      return {
        check: false,
        // 이용 중인 서비스  - 결제 완료 내역 (결제후)
        list1: [],
        // 이용 중인 서비스 - 다음 결제일 청구 예정 내역 (결제전)
        list2: [],
        // 이용 중인 서비스 - 다음 결제일 갱신 예정 내역 (결제후)
        list3: [],
        // 2021. 11. 1 (오늘) 변경 신청 시 정산 청구 내역
        list4: []
      }
    },
    computed: {
      vatPrice() {
        return this.accountPrice / 10;
      },
      accountTotalPrice() {
        return this.accountPrice + this.vatPrice;
      },
      accountPrice() {
        return this.totalPriceList3;
      },
      description() {
        return this.isUpgrade?`플랜 변경 시 변경한 날이 새로운 결제일이 되며,
        변경하지 않는 경우 ${this.datesFormat(this.service.service_order.next_date, 'date_3')} 결제 예정`:''
      },
      totalPriceList1() {
        let price = 0;
        this.list1.forEach(item=>{
          price += item.price;
        })
        return price;
      },
      totalPriceList2() {
        let price = 0;
        this.list2.forEach(item=>{
          price += item.price;
        })
        return price;
      },
      totalPriceList3() {
        let price = 0;
        this.list3.forEach(item=>{
          price += item.price;
        })
        return price;
      },
      totalPriceList4() {
        let price = 0;
        this.list4.forEach(item=>{
          price += item.price;
        })
        return price;
      },
      isUpgrade() {
        let is_upgrade = false;
        let current_date_unit = this.service.service_order.date_unit;
        let update_date_unit = this.order_product.date_unit;
        // 변경할 옵션값
        let update_option = undefined
        let current_option = undefined
        let stock = find(this.selectorStocks, 'id', this.order_product.order_product_option[0].option_id);
        this.order_product.product.selectors.forEach(item=>{
          let data = find(item.options, 'id', stock.options[0])
          if(data) update_option = data
        })

        stock = find(this.selectorStocks, 'id', this.service.service_order.options[0].id);
        this.order_product.product.selectors.forEach(item=>{
          let data = find(item.options, 'id', stock.options[0])
          if(data) current_option = data
        })

        // 업그레이드 여부
        if(current_option.grade < update_option.grade) {
          is_upgrade = true;
        } else if(current_option.grade > update_option.grade) {
          is_upgrade = false;
        } else {
          is_upgrade = current_date_unit < update_date_unit;
        }
        return is_upgrade
      },
      isFree() {
        return this.service.service_order.trial
      },
      currentDate() {
        return this.moment().format('YYYY.MM.DD')
      },
      // 청구 결제일
      list2PayDay() {
        let next_date = ''
        this.list2.forEach(item=>{
          if(!next_date) {
            next_date = item.next_date
          } else {
            if(this.moment(next_date) > this.moment(item.next_date)) {
              next_date = item.next_date
            }
          }
        })
        return next_date;
      },
      expectedPayDay() {
        return this.currentDate
      },
      solutionName() {
        let name = '';
        let item = find(this.selectorStocks, 'id', this.service.service_order.options[0].id)
        if(item) name = item.name;
        return name;
      },
      updateSolutionName() {
        let name = '';
        let item = find(this.selectorStocks, 'id', this.order_product.order_product_option[0].option_id)
        if(item) name = item.name;
        return name;
      },
      solutionPrice() {
        return this.getPlanPrice(this.service.service_order.options[0].id)
      },
      updateSolutionPrice() {
        return this.getPlanPrice(this.order_product.order_product_option[0].option_id, 'update_plan')
      },
      hostingPrice() {
        return this.service.service_order.hosting.price * this.service.service_order.date_unit;
      },
      updateHostingPrice() {
        return this.service.service_order.hosting.price * this.order_product.date_unit;
      },
      accountSolutionPrice() {
        let free_date = this.moment(this.datesFormat(this.service.service_order.free_date, 'date_4'))
        let start_date = this.moment(this.datesFormat(this.service.service_order.start_date, 'date_4'))
        // 무료 기간인 경우는 날짜에서 제외하고 계산
        let day = 0;
        if(this.isFree) {
          if (start_date < free_date) {
            day = this.moment(this.currentDate).diff(free_date.add(1, 'days'), 'days');
          } else {
            day = this.moment(this.currentDate).diff(start_date, 'days');
          }
        } else {
          day = this.moment(this.currentDate).diff(this.service.service_order.pay_day, 'days');
        }
        return this.calcSolutionOneDayPrice * day;
      },
      accountHostingPrice() {
        let free_date = this.moment(this.datesFormat(this.service.service_order.free_date, 'date_4'))
        let start_date = this.moment(this.datesFormat(this.service.service_order.start_date, 'date_4'))
        // 무료 기간인 경우는 날짜에서 제외하고 계산
        let day = 0;
        if(this.isFree) {
          if(start_date < free_date) {
            day = this.moment(this.currentDate).diff(free_date.add(1, 'days'), 'days');
          } else {
            day = this.moment(this.currentDate).diff(start_date, 'days');
          }
        } else {
          day = this.moment(this.currentDate).diff(this.service.service_order.pay_day, 'days');
        }
        return this.calcHostingOneDayPrice * day;
      },
      calcSolutionOneDayPrice() {
        let order = this.service.service_order;
        return Math.round(order.options[0].price / order.date_unit / 30)
      },
      calcHostingOneDayPrice() {
        let order = this.service.service_order;
        return Math.round(order.hosting.price / 30)
      },
    },
    methods: {
      initPlan() {
        // 변경할 플랜 정보 초기화 (list3)
        let item = {
          order_type: '솔루션',
          content1: this.updateSolutionName,
          content2: '',
          price: this.updateSolutionPrice,
          plan: this.order_product.date_unit + '개월',
          purchase_date: this.currentDate,
          next_date: this.expectedPayDay,
          start_date: this.expectedPayDay,
          end_date: this.datesFormat(this.moment(this.currentDate).add(this.order_product.date_unit, 'months'), 'date_3')
        }
        item['period'] = `${item['start_date']}~${item['end_date']}`
        this.list3.push(item);

        let item2 = {
          order_type: '호스팅',
          content1: '기본 호스팅',
          content2: '',
          price: this.updateHostingPrice,
          plan: this.order_product.date_unit + '개월',
          purchase_date: this.currentDate,
          next_date: this.expectedPayDay,
          start_date: this.expectedPayDay,
          end_date: this.datesFormat(this.moment(this.currentDate).add(this.order_product.date_unit, 'months'), 'date_3')
        }
        item2['period'] = `${item2['start_date']}~${item2['end_date']}`
        this.list3.push(item2)

        this.service.service_app_order.forEach(order=>{
          if(order.is_subscription) {
            this.list3.push(this.getOrderItem(order));
          } else if(!order.pay_day) {
            this.list3.push(this.getOrderItem(order));
          }
        })
      },
      getPlanPrice(option_id, type) {
        let date_unit = 1
        if(type==='update_plan') date_unit = this.order_product.date_unit
        else date_unit = this.service.service_order.date_unit
        let price = 0;
        let stock = find(this.selectorStocks, 'id', option_id);
        this.order_product.product.selectors.forEach(item=>{
          let data = find(item.options, 'id', stock.options[0])
          if(data) {
            if(date_unit===1) {
              price = data.price
            } else {
              let item = find(data.subscriptions, 'date_unit', date_unit)
              price = item.price
            }
          }
        })
        return price * date_unit
      },
      getOrderItem(order, type) {
        let item = undefined;
        if(type==='solution') {
          item = {
            order_type: '솔루션',
            content1: this.solutionName,
            content2: '',
            plan: order.date_unit + '개월',
            price: this.solutionPrice
          }
        }
        else if(type==='hosting') {
          item = {
            order_type: '호스팅',
            content1: '기본 호스팅',
            content2: '',
            plan: order.date_unit + '개월',
            price: this.hostingPrice
          }
        }
        else {
          item = {
            id: order.id,
            order_type: '앱마켓',
            content1: order.app_type==='plugin'?'플러그인':order.app_type==='package'?'플랫폼팩':'추가서비스',
            content2: order.product.name,
            price: order.subscribe_price * 10 / 11
          }
          if(order.app_type==='package') {
            item['plan'] = order.date_unit + '개월'
          } else {
            item['plan'] = order.is_subscription?'월결제':'건결제'
          }
        }
        item['purchase_date'] = this.datesFormat(order.created_time, 'date_3')
        item['pay_day'] = this.datesFormat(order.pay_day, 'date_3')
        if(this.isUpgrade) item['next_date'] = this.expectedPayDay
        else item['next_date'] = this.datesFormat(order.next_date, 'date_3')
        item['period'] = `${this.datesFormat(order.start_date, 'date_3')}~${this.datesFormat(order.end_date, 'date_3')}`
        // item = Object.assign({}, item, order)
        return item;
      },
      // 앱마켓인 경우 첫결제 여부, 1회결제
      isFirstPayAppMarket(order) {
        let free_date = this.moment(this.datesFormat(order.free_date, 'date_4'))
        let next_date = this.moment(this.datesFormat(order.next_date, 'date_4'))

        let item1 = free_date.add(1, 'days').format('YYYY-MM-DD');
        let item2 = next_date.format('YYYY-MM-DD')
        return item1===item2 && !order.is_subscription
      },
      saveData() {
        if(!this.check) {
          this.toast('결제 동의를 해주세요.');
          return;
        }
        let admin = this.$store.getters.admin;
        let url = `${this.masterBackendUrl}serviceadmin/${admin.id}/` + `launchpack/service/${this.service.id}/recover`
        // let url = `http://localhost:8001/serviceadmin/${admin.id}/` + `launchpack/service/${this.service.id}/recover`
        let params = {
          order_id: this.service.service_order.id,
          update_date_unit: this.order_product.date_unit,
          option_id: this.order_product.order_product_option[0].option_id,
          price: this.accountTotalPrice
        }
        this.$axios.post(url, params).then(res=>{
          if(res.status===200) {
            this.toast('플랜 변경 신청이 완료되었습니다.')
            this.$emit('done');
          }
        })
      },
      calcOneDayPrice(order) {
        return order.subscribe_price / order.date_unit / 30
      },
      // 주문의 현재 타입
      orderType(order) {
        // 0: 무료기간, 1: 결제후 2: 결제전
        let type = 0
        let now = this.moment(this.moment().format('YYYY-MM-DD'))
        let next_date = this.moment(order.next_date)
        let end_date = this.moment(order.end_date)
        if(this.isFree) type = 0
        // 현재일 < 결제일 < 이용기간종료일
        else if(now < next_date && end_date > next_date) type = 2
        else if(this.isFirstPayAppMarket(order)) type = 2
        else type = 1
        return type
      },
      computedPlan(order) {
        let text = '';
        // 정기 결제일 경우
        if(order.is_subscription) {
          text = order.date_unit + '개월'
        } else {
          text = '건 결제'
        }
        return text;
      }
    }
  }
</script>
<style lang="stylus" scoped>
  @import '~assets/css/lp_main'
  .amt-table th,
  .amt-table td
    text-align center
    padding 6px 0

  .amt-table th
    font-weight 500
    font-size 13px

  .amt-table td
    font-weight 400
    font-size 11px

  .amt-table tr
    border-bottom 1px solid #dddddd

  .amt-table tbody tr:last-child
    border-bottom 1px solid #000000

  .terminate-modal-title
    color #363636
    font-weight 500
    font-size 13px

  .terminate-modal-content
    color #363636
    font-weight 400
    font-size 11px

  .t-modal-btn
    width 230px
    height 32px
    background $primary
    color white
    border-radius 3px
    font-size 11px
    font-weight 400
</style>
